import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitoashtavinayakcab() {



const cardData = {
  keyword: " Navi Mumbai to Ashtavinayak Cab Service",

headingDescription:
"Omshree Cab provides reliable and comfortable Navi Mumbai to Ashtavinayak cab services for travelers planning a spiritual journey to the eight sacred Ganesha temples of Maharashtra. The Ashtavinayak Yatra is a revered pilgrimage route, visiting temples located in scenic towns such as Morgaon, Siddhatek, Theur, Lenyadri, Ozar, Ranjangaon, Vighnahar, and Mahad. Whether you are undertaking a religious tour, family pilgrimage, or group spiritual trip, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The distance from Navi Mumbai to the first temple on the route is approximately 100–150 km depending on the starting point, with total travel spanning multiple days for the full Ashtavinayak circuit. We provide flexible booking options including one-way trips, round-trip packages, and multi-day plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in highway and hilly routes, punctual pickups from anywhere in Navi Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai to Ashtavinayak cab booking.",

topPlaces: [
{
title: "Morgaon Ganapati Temple",
description:
"Morgaon is the primary temple in the Ashtavinayak Yatra, dedicated to Lord Ganesha as Shri Mayureshwar. It is renowned for its historic architecture, peaceful surroundings, and annual festivals. Pilgrims often visit to offer prayers, participate in rituals, and experience the spiritual atmosphere. Traveling by cab from Navi Mumbai ensures a comfortable and timely arrival for devotees."
},
{
title: "Siddhatek Ganapati Temple",
description:
"Siddhatek Temple, dedicated to Lord Ganesha as Shri Siddhivinayak, is situated on the banks of the Bhima River. This temple is known for its religious significance and scenic surroundings with hills nearby. Visitors can participate in daily rituals, enjoy the calm environment, and witness devotees performing traditional ceremonies. A cab from Navi Mumbai allows hassle-free access to this spiritual site."
},
{
title: "Theur Ganapati Temple",
description:
"Theur Temple is dedicated to Lord Ganesha as Shri Chintamani and features historic architecture, intricate carvings, and a serene temple complex. Pilgrims visit to offer prayers, seek blessings, and experience the devotional environment. Traveling by cab from Navi Mumbai ensures comfortable transportation and allows devotees to explore the temple without worrying about local commute."
},
{
title: "Lenyadri Ganapati Temple",
description:
"Lenyadri Temple is a unique cave temple dedicated to Lord Ganesha as Shri Girijatmak, located on a hill with scenic views of the surrounding landscape. Devotees climb the steps to reach the sanctum, enjoy panoramic views, and experience the spiritual ambiance. A cab service from Navi Mumbai provides safe and convenient travel to this hill temple."
},
{
title: "Ozar Ganapati Temple",
description:
"Ozar Temple is dedicated to Lord Ganesha as Shri Vigneshwar and is located along the banks of the Kukadi River. The temple is famous for its beautiful surroundings, traditional architecture, and lively festivals. Visitors can enjoy the calm river views while participating in rituals. Traveling by cab from Navi Mumbai allows pilgrims to comfortably include this temple in their Ashtavinayak Yatra itinerary."
},
{
title: "Ranjangaon Ganapati Temple",
description:
"Ranjangaon Temple is dedicated to Lord Ganesha as Shri Mahaganapati and is well-known for its large idol and detailed carvings. The temple attracts devotees seeking blessings for prosperity and success. Travelers can explore the temple complex and nearby markets comfortably when using a cab from Navi Mumbai."
},
{
title: "Vighnahar Ganapati Temple",
description:
"Vighnahar Temple, located in Ozar, is dedicated to Lord Ganesha as Shri Vighnahar. It is famous for its religious rituals, serene surroundings, and devotees who visit to seek blessings. A cab ride from Navi Mumbai ensures timely and safe travel to this sacred site while maintaining comfort throughout the journey."
},
{
title: "Mahad Ganapati Temple",
description:
"Mahad Temple, dedicated to Lord Ganesha as Shri Chintamani, is set in a tranquil location with lush surroundings. Pilgrims visit to perform prayers, participate in rituals, and enjoy the peaceful ambiance. Traveling by cab from Navi Mumbai offers a comfortable, convenient, and hassle-free experience to complete the Ashtavinayak pilgrimage."
}
],



services: [
{
name: "Navi Mumbai to Ashtavinayak Cab",
description: "Navi Mumbai to Ashtavinayak cab service provides comfortable pilgrimage travel for devotees visiting the famous eight Ganpati temples of Maharashtra. The Ashtavinayak Darshan tour covers sacred temples like Moreshwar, Siddhatek, Ballaleshwar, Varadvinayak, Chintamani, Girijatmaj, Vighneshwar, and Mahaganapati. Our cab service offers comfortable sedans, SUVs, and MPV vehicles suitable for long spiritual journeys. Professional drivers ensure safe driving and convenient temple visits throughout the tour. The service is ideal for families, devotees, and pilgrimage groups traveling from Navi Mumbai. Passengers enjoy air-conditioned comfort and flexible travel schedules. It is a reliable option for a peaceful and well-planned Ashtavinayak Darshan journey."
},
{
name: "Navi Mumbai to Ashtavinayak Taxi",
description: "Navi Mumbai to Ashtavinayak taxi service offers reliable transportation for devotees planning the sacred Ganpati temple tour. The taxi provides comfortable seating and smooth highway travel for long pilgrimage journeys. Professional drivers ensure punctual pickup services from homes, hotels, and railway stations in Navi Mumbai. The journey allows travelers to visit all eight holy temples comfortably. Vehicles are well maintained with spacious interiors and powerful AC. Devotees enjoy peaceful travel during their spiritual trip. The taxi service ensures safe and comfortable pilgrimage transportation."
},
{
name: "Ashtavinayak Darshan Cab Navi Mumbai",
description: "Ashtavinayak Darshan cab from Navi Mumbai provides a dedicated temple tour for devotees wishing to complete the sacred Ganpati pilgrimage. The cab allows passengers to travel comfortably between the eight holy temples across Maharashtra. Professional drivers guide travelers through the most efficient routes to cover the temples. Vehicles provide spacious seating and smooth ride quality suitable for long journeys. Families and groups can enjoy convenient temple visits without travel stress. The service offers flexible travel plans for spiritual trips. Devotees experience comfortable and reliable transportation throughout the darshan tour."
},
{
name: "Ashtavinayak Temple Tour Cab Navi Mumbai",
description: "Ashtavinayak temple tour cab Navi Mumbai provides complete pilgrimage transportation for travelers visiting the famous Ganpati temples. The cab service allows devotees to explore all eight sacred temples in a single tour or multi-day journey. Vehicles provide comfortable seating and air-conditioned interiors for long-distance travel. Professional drivers ensure safe driving and convenient temple stops. Families and senior citizens can travel comfortably throughout the pilgrimage. The service is ideal for spiritual tours and religious travel groups. Passengers enjoy a peaceful and organized temple tour experience."
},
{
name: "Navi Mumbai Ashtavinayak Cab Service",
description: "Navi Mumbai Ashtavinayak cab service provides dependable transportation for devotees planning temple darshan trips. The vehicles include comfortable sedans and SUVs suitable for long highway travel. Professional drivers ensure punctual pickups and safe travel throughout the pilgrimage route. The service supports both one-day and multi-day Ashtavinayak tours. Travelers enjoy comfortable seating and reliable transportation during their journey. Families and spiritual travelers benefit from convenient temple visits. The cab service ensures a smooth and enjoyable pilgrimage experience."
},
{
name: "Navi Mumbai Ashtavinayak Taxi Service",
description: "Navi Mumbai Ashtavinayak taxi service offers convenient temple tour transportation for pilgrims visiting the eight sacred Ganpati temples. The taxi provides comfortable seating and reliable highway performance for long journeys. Professional drivers ensure safe driving and timely pickups from Navi Mumbai locations. The service allows devotees to travel peacefully and complete their darshan comfortably. Vehicles provide spacious interiors and air-conditioned comfort. Families and groups enjoy convenient pilgrimage travel. The taxi service guarantees dependable transportation for religious trips."
},
{
name: "Navi Mumbai to Ashtavinayak Cab Booking",
description: "Navi Mumbai to Ashtavinayak cab booking allows travelers to easily reserve vehicles for the Ganpati temple pilgrimage. Customers can choose from sedans, SUVs, or spacious MPV vehicles depending on group size. Online and phone booking options provide quick confirmation for the temple tour. Professional drivers ensure punctual pickup and safe driving throughout the journey. Travelers enjoy flexible travel schedules to visit all temples peacefully. Vehicles offer comfortable interiors and smooth ride performance. The service ensures convenient booking for pilgrimage trips."
},
{
name: "Navi Mumbai to Ashtavinayak Taxi Booking Online",
description: "Navi Mumbai to Ashtavinayak taxi booking online provides quick digital reservations for devotees planning the Ganpati temple tour. Travelers can easily schedule taxis online and receive instant confirmation. Vehicles provide comfortable seating and reliable highway performance for long-distance journeys. Professional drivers ensure punctual pickups and safe travel throughout the route. The service is ideal for families and spiritual travelers. Online booking makes travel planning simple and convenient. Passengers enjoy hassle-free pilgrimage transportation."
},
{
name: "Navi Mumbai to Ashtavinayak Cab Price",
description: "Navi Mumbai to Ashtavinayak cab price options provide transparent travel cost estimates for temple tour packages. Pricing depends on vehicle category, travel duration, and tour route. Customers can choose economical sedans or spacious SUVs according to their comfort needs. The cab service offers competitive fares for pilgrimage trips. Travelers receive clear pricing details before booking their journey. Vehicles ensure comfortable and reliable transportation. The service offers affordable pilgrimage travel options."
},
{
name: "Navi Mumbai to Ashtavinayak Taxi Fare",
description: "Navi Mumbai to Ashtavinayak taxi fare services offer flexible pricing depending on vehicle type and travel schedule. Travelers can select suitable vehicles for family or group travel. Professional drivers ensure safe and comfortable transportation during the temple tour. The taxi provides spacious seating and AC interiors for relaxed travel. Passengers enjoy convenient pilgrimage journeys without transportation worries. Transparent pricing helps travelers plan their trip easily. The service ensures dependable travel at fair rates."
},
{
name: "Ashtavinayak One Day Tour Cab Navi Mumbai",
description: "Ashtavinayak one day tour cab Navi Mumbai provides fast and convenient temple tour travel for devotees wishing to complete the pilgrimage in a single day. The cab service follows efficient routes to cover the eight sacred Ganpati temples. Vehicles provide comfortable seating and reliable highway performance. Professional drivers ensure safe driving and timely temple visits. Families and devotees enjoy organized pilgrimage travel. The service offers flexible schedules for temple darshan. Travelers experience a peaceful and comfortable spiritual journey."
},
{
name: "Innova Cab Ashtavinayak Tour",
description: "Innova cab Ashtavinayak tour provides spacious MPV transportation ideal for families and pilgrimage groups. The Toyota Innova offers comfortable seating and smooth highway performance suitable for long spiritual journeys. Professional drivers ensure safe driving and convenient temple stops during the tour. The vehicle provides ample luggage space and strong AC cooling for comfortable travel. Devotees can enjoy relaxed journeys between temples. It is perfect for group pilgrimage travel. The service offers premium comfort for the Ashtavinayak temple tour."
}
],

tableData: [
["Navi Mumbai to Ashtavinayak Cab","Navi Mumbai to Ashtavinayak Taxi"],
["Ashtavinayak Darshan Cab Navi Mumbai","Ashtavinayak Temple Tour Cab Navi Mumbai"],
["Navi Mumbai Ashtavinayak Cab Service","Navi Mumbai Ashtavinayak Taxi Service"],
["Navi Mumbai to Ashtavinayak Cab Booking","Navi Mumbai to Ashtavinayak Taxi Booking Online"],
["Navi Mumbai to Ashtavinayak Cab Price","Navi Mumbai to Ashtavinayak Taxi Fare"],
["Ashtavinayak One Day Tour Cab Navi Mumbai","Innova Cab Ashtavinayak Tour"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are well experienced with Navi Mumbai International Airport routes, terminals, and nearby highways. They ensure smooth airport pickups and drop services without delays."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai International Airport cab services. Customers receive clear information about fares, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai International Airport cab service operates 24 hours a day. Whether your flight arrives early morning or late at night, our cabs are always available for reliable airport transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Options",
    WhyChoosedescription: "We offer flexible travel options including airport pickup, airport drop, one-way cabs, and round-trip bookings from Navi Mumbai International Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business locations across Navi Mumbai for seamless airport transfers."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai International Airport transfers thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai International Airport?", answer: "Yes, Omshree Cabs provides reliable cab services for pickup and drop at Navi Mumbai International Airport." },
  { question: "Is the airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight schedules." },
  { question: "Which vehicles are available for airport transfers?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way airport drop?", answer: "Yes, we offer one-way airport pickup and drop services." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, and offices across Navi Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book airport cab service online?", answer: "Yes, customers can easily book airport cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and holidays." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, we provide airport transfer services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "Booked Omshree Cabs for Navi Mumbai International Airport pickup. The driver arrived on time and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Excellent airport cab service. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers comfortable and reliable cab services from Navi Mumbai to Ashtavinayak temples. Ideal for one-day temple tours, we provide Innova cabs, one-way or round-trip bookings, with experienced drivers for a smooth pilgrimage experience.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai to Ashtavinayak Cab",
    "Ashtavinayak Temple Tour Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Innova Cab",
    "Pilgrimage Cab Service",
    "One Day Tour Cab"
  ]
};





  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to Ashtavinayak Cab Service | Omshree Cab</title>
  <meta
    name="description"
    content="Book a reliable cab from Navi Mumbai to Ashtavinayak temples with Omshree Cab. We offer Innova cabs for one-day temple tours, one-way or round trips, ensuring a comfortable and safe pilgrimage experience."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitoashtavinayakcab;